module.exports = {
  DRAG_START: 'DRAG_START',
  DRAG_STOP:  'DRAG_STOP',
  DRAG_MOVE:  'DRAG_MOVE',
}



// WEBPACK FOOTER //
// ../build/constants.js